import Vue from 'vue'
import App from './index.vue'
import * as saService from '../../../common/js/sa-service'

saService.initSaAutoTrack()
saService.trackPageVisit()

new Vue({
  el: '#app',
  render: h => h(App)
})





// WEBPACK FOOTER //
// ./src/pages/site/index/index.js